/**
 * McpStatusRefresher — fragt beim Laden der App den Orakel-Status ab (PV-045).
 *
 * Die API erneuert dabei einen abgelaufenen Zugang still. Die Komponente zeigt nichts,
 * meldet nichts und navigiert nie: Entweder klappt es im Hintergrund, oder Briefing-Reiter
 * und Einstellungen zeigen ihren Hinweis. Der Query-Key ist mit beiden geteilt.
 */
import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api.js';

/** Einmal je halbe Stunde reicht: die API frischt ohnehin nur nahe am Ablauf auf. */
const MCP_STATUS_STALE_MS = 30 * 60_000;

export function McpStatusRefresher() {
  useQuery({
    queryKey: ['mcp-status'],
    queryFn: () => api.getMcpStatus(),
    staleTime: MCP_STATUS_STALE_MS,
    retry: false,
    refetchOnWindowFocus: false,
    throwOnError: false,
  });
  return null;
}
